<footer>
  <div class="g-container">
    <div class="sp-6 copyright-container">
      <a
        [routerLink]="['/']"
        [setSVGAttributes]="{ alt: 'Flow' }"
        class="logo"
        inlineSVG="/assets/icons/logo-purple.svg"
      >
      </a>
      <p class="copyright">© 2022 – Flow Inc., All rights reserved.</p>
    </div>
    <div class="sp-6">
      <ul class="footer-links">
        <li>
          <h2>Resources</h2>
          <ul class="links-list">
            <li>
              <a href="https://www.linkedin.com/company/flowinc/" target="_blank" tabindex="0">LinkedIn</a>
            </li>
            <li>
              <a href="{{ TERMS_OF_USE_URL }}" tabindex="0">Terms of Use</a>
            </li>
            <li>
              <a href="{{ PRIVACY_POLICY_URL }}" tabindex="0">Privacy Policy</a>
            </li>
          </ul>
        </li>
        <li>
          <h2>Contact</h2>
          <ul class="links-list">
            <li>
              <a href="https://help.flowinc.com" target="_blank">Support</a>
            </li>
            <li>
              <a class="sales-inquiry" href="mailto:sales@flowinc.com" target="_blank" tabindex="0"
                >Sales Inquiries</a
              >
            </li>
          </ul>
        </li>
        <li>
          <h2>Company</h2>
          <ul class="links-list">
            <li>
              <a [routerLink]="['/team']" tabindex="0">Team</a>
            </li>
            <li>
              <a href="https://jobs.lever.co/flowinc" target="_blank" tabindex="0">Careers</a>
            </li>
            <li>
              <a href="https://blog.flowinc.com/" tabindex="0">Blog</a>
            </li>
          </ul>
        </li>
      </ul>
      <p *ngIf="isSvbPage" class="svb-footnote" id="svb-footnote">
        <sup>1</sup>Deposit products are offered by Silicon Valley Bank. © 2022 SVB Financial Group. All
        rights reserved. Silicon Valley Bank is a member of the FDIC and of the Federal Reserve System.
        Silicon Valley Bank is the California bank subsidiary of SVB Financial Group (Nasdaq: SIVB). Flow is
        an independent third party and is not affiliated with SVB Financial Group. SVB, SVB FINANCIAL GROUP,
        SILICON VALLEY BANK, MAKE NEXT HAPPEN NOW and the chevron device are trademarks of SVB Financial
        Group, used under license.
      </p>
    </div>
  </div>
  <p *ngIf="env.runtimeEnv !== 'production'" class="flow-hash">Flow Hash: {{ version.hash }}</p>
</footer>
